export const HOME_ROUTE = "3659a581-a087-4b8e-820c-163c7809cfae"
export const DISCOVER_ROUTE = "f0db6727-27cd-4151-85c9-0c2bab4ddc3a"
export const PLANNING_ROUTE = "56f216e7-8ebf-40a0-aabf-1878db65c108"
export const REVIEWS_CONTENT = "06362b4d-4510-4ca1-9be8-8b071056a1b3"
export const COMPARISON_CONTENT = "7ceb81f8-bfcd-46c1-aad7-37517aeca983"
export const PRIVACY_ROUTE = "ef041102-76af-4e72-a9d9-cd26fd05f004"
export const DISCLAIMER_ROUTE = "1437d787-c447-47f6-8ea6-ed039fb7a7ea"
export const PII_ROUTE = "6586eb1d-9e54-43a6-8dbc-dd00f3161d05"
